module.exports = "form input[type=\"submit\"]{    \n    opacity: 1;\n    position: relative;\n    padding: 10px 0px;\n    background-color: #314aae;\n    color: #fff;\n    display: inline-block;\n    text-transform: uppercase;\n    border-radius: 3px;\n}\n.marginleft17{margin-left: 17px !important;}\n.banner_home{    \n    width: 100%;\n}\n.channellist{\n    font-weight: bold;\n    color: #2c47b1;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-page/home-page.component.css
// module id = ./src/app/home-page/home-page.component.css
// module chunks = main